import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getAssetNames } from "actions/asset";
import { getPortfolios, switchPortfolios } from "actions/portfolio";
import isEqual from "lodash/isEqual";
import PropTypes from "prop-types";

import { DataStorage } from "utils";
import { isAuthenticated } from "utils/Authenticated";
import { getUrlParams } from "utils/urlParams";

const getPortfolioIDs = () => {
  const { portfolioIDs } = getUrlParams();

  return portfolioIDs ? portfolioIDs.map((i) => parseInt(i, 10)) : [];
};

class PortfolioInitializer extends React.Component {
  constructor(props) {
    super(props);
    const { getAssets, initializePortfolios } = this.props;
    if (isAuthenticated()) {
      initializePortfolios();
      getAssets();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { selectedPortfolioIDs, setPortfolioIDs } = this.props;
    if (isAuthenticated() && selectedPortfolioIDs.length && nextProps.history.action === "POP") {
      if (
        getPortfolioIDs().length &&
        !isEqual([...(selectedPortfolioIDs || [])].sort(), [...getPortfolioIDs()].sort())
      ) {
        setPortfolioIDs(getPortfolioIDs());
      }
    }
  }

  render() {
    return <>{this.props.children}</>;
  }
}

PortfolioInitializer.propTypes = {
  children: PropTypes.node,
  getAssets: PropTypes.func,
  initializePortfolios: PropTypes.func.isRequired,
  setPortfolioIDs: PropTypes.func.isRequired,
  selectedPortfolioIDs: PropTypes.arrayOf(PropTypes.number),
  history: PropTypes.shape({
    action: PropTypes.string,
  }),
};

const mapStateToProps = ({ selectedPortfolioIDs }) => ({
  selectedPortfolioIDs,
});

const mapDispatchToProps = (dispatch) => ({
  getAssets: () => dispatch(getAssetNames()),
  initializePortfolios: () => {
    dispatch(getPortfolios()).then(() => {
      const pathPortfolioIDs = getPortfolioIDs();
      const portfolioIDs =
        pathPortfolioIDs.length > 0 ? pathPortfolioIDs : DataStorage.getSelectedPortfolioIDs();
      dispatch(switchPortfolios(portfolioIDs));
    });
  },
  setPortfolioIDs: (portfolioIDs) => dispatch(switchPortfolios(portfolioIDs)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PortfolioInitializer));
